export default __webpack_public_path__ + "static/media/slic3r.8850649f.svg";